var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPageNotAvailableSmall = function SvgPageNotAvailableSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "236px",
    height: "116px",
    viewBox: "0 0 236 116",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "not_available_small")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Salesforce-Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration_small_not_available",
    transform: "translate(-32.000000, -44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-Empty-State-/-z-nested-/-Not-Available-/-Small"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PageNotAvailable"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 300,
    height: 200
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mountain",
    transform: "translate(33.500000, 133.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 18.5,
    x2: 233,
    y2: 18.5,
    id: "HorizonLineBack2",
    stroke: "#C2E8FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 18.5,
    x2: 3,
    y2: 18.5,
    id: "HorizonLineBack1",
    stroke: "#C2E8FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "MountainLine4",
    stroke: "#C2E8FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "21.5 18 44 0 60.75 13.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "MountainLine1",
    stroke: "#C2E8FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "55.5 8.5 61 4.5 76.5 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.962964,8.93915721 L28.5,18 L28.5,18 L22.885109,13.0531821 L24.037036,8.93915721 C24.1859485,8.40732687 24.7377996,8.09691062 25.2696299,8.24582312 C25.6059625,8.33999625 25.8687909,8.60282459 25.962964,8.93915721 Z",
    id: "MountainTree",
    fill: "#C2E8FF",
    transform: "translate(25.692555, 12.313441) scale(-1, 1) translate(-25.692555, -12.313441) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tree2",
    transform: "translate(224.750000, 118.250000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tree2White",
    transform: "translate(1.000000, 0.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4209988,4.29236217 L16.259296,24.443436 C16.5666778,25.5043744 15.9557995,26.613617 14.8948612,26.9209988 C14.7139843,26.9734036 14.5266126,27 14.3382972,27 L2.6617028,27 C1.5571333,27 0.661702805,26.1045695 0.661702805,25 C0.661702805,24.8116846 0.688299176,24.6243129 0.74070397,24.443436 L6.57900117,4.29236217 C6.88638297,3.23142381 7.99562563,2.62054553 9.05656399,2.92792733 C9.71521023,3.11875451 10.2301717,3.63371594 10.4209988,4.29236217 Z",
    id: "Tree2WhiteBkgd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tree2LightBlue",
    stroke: "#C2E8FF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Tree2LightBlueOutline1",
    strokeLinejoin: "round",
    points: "9.75 0.161971831 18.75 26.25 0.75 26.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75,2.34765625 C9.75,21.5228147 9.75,31.323596 9.75,31.75 C9.75,31.323596 9.75,21.5228147 9.75,2.34765625 Z",
    id: "Tree2LightBlueLine2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,14.6619718 C13.1666667,17.8925806 14.5,19.5592472 14.5,19.6619718 C14.5,19.5592472 13.1666667,17.8925806 10.5,14.6619718 Z",
    id: "Tree2LightBlueLine1",
    strokeLinejoin: "round",
    transform: "translate(12.500000, 17.161972) scale(-1, 1) translate(-12.500000, -17.161972) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tree1",
    transform: "translate(204.000000, 101.750000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tree1White",
    transform: "translate(0.500000, 0.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8239437,0 L25.0550983,40.9273253 C25.3713779,41.9856452 24.7698353,43.0999782 23.7115153,43.4162577 C23.5256938,43.4717906 23.3327828,43.5 23.1388406,43.5 L2.5090467,43.5 C1.40447721,43.5 0.509046705,42.6045695 0.509046705,41.5 C0.509046705,41.3060578 0.537256095,41.1131469 0.592788981,40.9273253 L12.8239437,0 L12.8239437,0 Z",
    id: "Tree1WhiteBkgd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tree1LightBlue",
    stroke: "#C2E8FF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Tree1LightBlueOutine",
    strokeLinejoin: "round",
    points: "13.5 0 27.25 42.75 0.25 42.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,1.79321289 C13.5,32.0130517 13.5,47.4986474 13.5,48.25 C13.5,47.4986474 13.5,32.0130517 13.5,1.79321289 Z",
    id: "Tree1LightBlueLine3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82394366,21 C11.4906103,24.539346 13.3239437,26.3726794 13.3239437,26.5 C13.3239437,26.3726794 11.4906103,24.539346 7.82394366,21 Z",
    id: "Tree1LightBlueLine2",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8239437,34 C18.4906103,28.539346 20.8239437,25.8726794 20.8239437,26 C20.8239437,25.8726794 18.4906103,28.539346 13.8239437,34 Z",
    id: "Tree1LightBlueLine1",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Axe",
    transform: "translate(162.012193, 82.064415) rotate(-45.000000) translate(-162.012193, -82.064415) translate(121.012193, 65.064415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AxeWhite",
    transform: "translate(2.500000, 22.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.09473989,0.497805891 L0.0576171875,5.97776273 C6.0478998,9.72885715 9.16694247,11.6507685 9.4147452,11.7434968 C9.5834602,11.8066303 10.8806271,12.019991 13.4850977,11.8881637 C14.2990212,11.8469663 15.8173328,11.6811806 18.0400323,11.3908066 C20.0230996,10.84141 21.5137898,10.3580938 22.5121029,9.94085788 C23.510416,9.52362194 25.1732794,8.68893901 27.5006929,7.43680908 L23.7638684,1.60939294 L2.09473989,0.497805891 Z",
    id: "AxeEdge"
  })), /*#__PURE__*/React.createElement("g", {
    id: "AxeLightBlue",
    transform: "translate(0.500000, 0.000000)",
    fill: "#C2E8FF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "HandleShortBkgd",
    x: 0.486620155,
    y: 5.49791048,
    width: 5.75,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.38877573,25.1142391 C6.64310102,26.3181284 10.7404785,26.8968298 14.6809082,26.8503434 C18.6213379,26.8038569 22.3882791,25.8700484 25.9817318,24.0489178 C25.0375626,22.2335225 24.3913379,20.8949225 24.0430577,20.0331175 C23.6947776,19.1713126 23.2618128,17.8395028 22.7441633,16.037688 L22.647316,0.14660248 L6.28476837,0.0740964133 L6.28632207,16.0083403 C5.78694868,18.2311606 5.30984725,19.8738834 4.85501779,20.9365086 C4.40018833,21.9991338 3.57810764,23.3917106 2.38877573,25.1142391 Z",
    id: "AxeShapeBkgd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7170505,5.39991373 L80.4670505,5.39991373 L80.4670505,14.6037929 C69.398447,12.4574528 60.648447,11.4347996 54.2170505,11.5358332 C51.9737644,11.5358332 48.4819431,11.5358332 43.7415867,11.5358332 L22.7170505,11.5358332 L22.7170505,5.39991373 Z",
    id: "HandleLongBkgd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "AxeDarkBlue",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75075724,4.547e-13 L23.2527085,4.547e-13 L23.2527085,12.0258065 C23.0402703,14.8054429 23.508083,17.5613569 24.6561465,20.2935484 C25.80421,23.0257399 27.5866634,26.0321915 30.0035068,29.3129032 C24.7528859,32.3193548 19.7522946,33.8225806 15.0017329,33.8225806 C10.2511712,33.8225806 5.25057986,32.3193548 -4.10008991e-05,29.3129032 C2.8770388,25.2974031 4.73523187,22.2909515 5.5745382,20.2935484 C6.41384453,18.2961453 6.80591755,15.5402313 6.75075724,12.0258065 L6.75075724,4.547e-13 Z",
    id: "AxeShapeOutline",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "HandleShort",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 0.986620155,
    y: 5.49791048,
    width: 5.75,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2170505,5.39991373 L80.9670505,5.39991373 L80.9670505,14.6037929 C69.898447,12.4574528 61.148447,11.4347996 54.7170505,11.5358332 C52.4737644,11.5358332 48.9819431,11.5358332 44.2415867,11.5358332 L23.2170505,11.5358332 L23.2170505,5.39991373 Z",
    id: "HandleLong",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Handle",
    fill: "#8CD3F8",
    points: "33 5.26129032 51 5.26129032 51.0811412 11.5112903 33.0271307 11.4486902"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Stump",
    transform: "translate(60.000000, 109.759329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "StumpWhite",
    transform: "translate(60.500000, 1.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "StumpHighlight",
    points: "0.0576171875 0.411569606 0.0576171875 3.47895242 65.5644531 10.5624485 65.5644531 7.48774148"
  })), /*#__PURE__*/React.createElement("g", {
    id: "StumpLightBlue",
    transform: "translate(49.500000, 4.000000)",
    fill: "#C2E8FF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    points: "10.9833984 0.106882106 76.3310547 7.49067117 76.3310547 30.9818821 80.4335938 38.0717259 87.3144531 44.160593 0.318359375 44.160593 6.87402344 38.0717259 10.9833984 28.6488743"
  })), /*#__PURE__*/React.createElement("g", {
    id: "StumpDarkBlue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.5,7.74067117 L61.5,30.7406712 C61.0439453,35.9190552 59.6669922,39.6591545 57.3691406,41.960969 C55.0712891,44.2627835 52.4482422,46.5226842 49.5,48.7406712 L137.5,48.7406712 C134.613607,46.4209156 132.089844,43.7010434 129.928711,40.5810547 C127.767578,37.4610659 126.624674,33.7534025 126.5,29.4580645 L126.5,0.240671168 L61.5,7.74067117 Z",
    id: "StumpOutline",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(93.500000, 24.490671) scale(-1, 1) translate(-93.500000, -24.490671) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.428751,39.5526781 L142,48.5 L142,48.5 L133,48.5 L136.571249,39.5526781 C136.775982,39.0397429 137.357768,38.7898963 137.870703,38.9946301 C138.125359,39.0962737 138.327108,39.2980226 138.428751,39.5526781 Z",
    id: "Grass4",
    fill: "#8CD3F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.678751,43.3107426 L145.75,48.5 L145.75,48.5 L139.75,48.5 L141.821249,43.3107426 C142.025982,42.7978074 142.607768,42.5479608 143.120703,42.7526946 C143.375359,42.8543382 143.577108,43.0560871 143.678751,43.3107426 Z",
    id: "Grass3",
    fill: "#8CD3F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6787513,39.5526781 L51.25,48.5 L51.25,48.5 L42.25,48.5 L45.8212487,39.5526781 C46.0259825,39.0397429 46.6077681,38.7898963 47.1207033,38.9946301 C47.3753588,39.0962737 47.5771077,39.2980226 47.6787513,39.5526781 Z",
    id: "Grass2",
    fill: "#8CD3F8",
    transform: "translate(46.750000, 43.499394) scale(-1, 1) translate(-46.750000, -43.499394) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9287513,43.3107426 L43,48.5 L43,48.5 L37,48.5 L39.0712487,43.3107426 C39.2759825,42.7978074 39.8577681,42.5479608 40.3707033,42.7526946 C40.6253588,42.8543382 40.8271077,43.0560871 40.9287513,43.3107426 Z",
    id: "Grass1",
    fill: "#8CD3F8",
    transform: "translate(40.000000, 45.378426) scale(-1, 1) translate(-40.000000, -45.378426) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 48.7406712,
    x2: 187,
    y2: 48.7406712,
    id: "HorizonLine2",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 48.7406712,
    x2: 6,
    y2: 48.7406712,
    id: "HorizonLine1",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.5,7.24067117 L114.5,20.2406712 C114.111816,29.7610162 118.278483,35.5943496 127,37.7406712",
    id: "StumpLine6",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5,6.24067117 L107.5,25.7406712 C107.414714,37.7230552 115.415039,43.7230552 131.500977,43.7406712",
    id: "StumpLine5",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.5,
    y1: 4.74067117,
    x2: 97.5,
    y2: 48.2406712,
    id: "StumpLine4",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.5,
    y1: 2.74067117,
    x2: 82.5,
    y2: 48.2406712,
    id: "StumpLine3",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5,2.24067117 L76.5,30.2406712 C76.1666667,42.1681101 67.8173828,48.1318296 51.4521484,48.1318296",
    id: "StumpLine2",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5,1.24067117 L68.5,27.1101563 C68.4609375,38.1181536 63.9609375,43.6221522 55,43.6221522",
    id: "StumpLine1",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Cloud1",
    transform: "translate(81.000000, 53.748815)",
    stroke: "#C2E8FF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud1LightBlue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,8.79146919 L31.5,8.79146919 C31.1394857,6.06480614 32.0407715,3.78378292 34.2038574,1.94839955 C36.6877441,-0.0982417247 39.6367188,0.360587604 41.220459,1.06679965 C42.8041992,1.7730117 43.9803467,2.74328671 44.7956543,4.5741966 C45.1411133,5.34508018 45.3758952,5.99728321 45.5,6.53080569",
    id: "Cloud1LightBlueLine4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5,10.2985782 C42.0279134,8.46301559 43.1113688,7.26289664 44.7503662,6.69822136 C47.2088623,5.85120844 49.5400391,6.97920986 50.4711914,8.11420227 C51.4023438,9.24919468 51.6975098,10.1609662 51.873291,11.1124759 C51.9904785,11.7468158 52.0327148,12.4802559 52,13.3127962 L54.081543,13.3127962 C56.0183919,13.8295019 56.9937985,14.9811653 57.0077626,16.7677864 C57.0322678,19.9575033 54.6954577,20.7511848 53.5,20.7511848 L14,20.7511848",
    id: "Cloud1LightBlueLine3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 14.7511848,
    x2: 41.5002493,
    y2: 14.7511848,
    id: "Cloud1LightBlueLine2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 14.7511848,
    x2: 4,
    y2: 14.7511848,
    id: "Cloud1LightBlueLine1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Cloud2",
    transform: "translate(160.000000, 73.748815)",
    stroke: "#C2E8FF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud2LightBlue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,8.79146919 L31.5,8.79146919 C31.1394857,6.06480614 32.0407715,3.78378292 34.2038574,1.94839955 C36.6877441,-0.0982417247 39.6367188,0.360587604 41.220459,1.06679965 C42.8041992,1.7730117 43.9803467,2.74328671 44.7956543,4.5741966 C45.1411133,5.34508018 45.3758952,5.99728321 45.5,6.53080569",
    id: "Cloud2LightBlueLine4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5,10.2985782 C42.0279134,8.46301559 43.1113688,7.26289664 44.7503662,6.69822136 C47.2088623,5.85120844 49.5400391,6.97920986 50.4711914,8.11420227 C51.4023438,9.24919468 51.6975098,10.1609662 51.873291,11.1124759 C51.9904785,11.7468158 52.0327148,12.4802559 52,13.3127962 L54.081543,13.3127962 C56.0183919,13.8295019 56.9937985,14.9811653 57.0077626,16.7677864 C57.0322678,19.9575033 54.6954577,20.7511848 53.5,20.7511848 L14,20.7511848",
    id: "Cloud2LightBlueLine3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 14.7511848,
    x2: 41.5002493,
    y2: 14.7511848,
    id: "Cloud2LightBlueLine2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 14.7511848,
    x2: 4,
    y2: 14.7511848,
    id: "Cloud2LightBlueLine1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Branch",
    transform: "translate(88.500000, 108.259329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BranchWhite",
    transform: "translate(3.000000, 1.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4090097,20.0331214 L10.4090097,1.99441174 C7.40900974,4.68648021 5.90900974,7.69293183 5.90900974,11.0137666 C5.90900974,14.3346013 7.40900974,17.3410529 10.4090097,20.0331214 Z",
    id: "LeafHighLight2",
    transform: "translate(8.159010, 11.013767) scale(-1, -1) rotate(-45.000000) translate(-8.159010, -11.013767) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0366498,10.6642493 L20.0366498,-0.609944274 C18.1616498,1.07259852 17.2241498,2.95163078 17.2241498,5.0271525 C17.2241498,7.10267422 18.1616498,8.98170648 20.0366498,10.6642493 Z",
    id: "LeafHighLight1",
    transform: "translate(18.630400, 5.027153) scale(1, -1) rotate(-45.000000) translate(-18.630400, -5.027153) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "BranchLightBlue",
    transform: "translate(0.000000, 3.000000)",
    fill: "#C2E8FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4090097,21.0331214 L10.4090097,2.99441174 C7.40900974,5.68648021 5.90900974,8.69293183 5.90900974,12.0137666 C5.90900974,15.3346013 7.40900974,18.3410529 10.4090097,21.0331214 Z",
    id: "LeafBkgd2",
    transform: "translate(8.159010, 12.013767) rotate(-45.000000) translate(-8.159010, -12.013767) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9631189,10.6642493 L24.9631189,-0.609944274 C23.0881189,1.07259852 22.1506189,2.95163078 22.1506189,5.0271525 C22.1506189,7.10267422 23.0881189,8.98170648 24.9631189,10.6642493 Z",
    id: "LeafBkgd",
    transform: "translate(23.556869, 5.027153) scale(-1, 1) rotate(-45.000000) translate(-23.556869, -5.027153) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "BranchDarkBlue",
    stroke: "#8CD3F8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31,32.2406712 C21.7779948,29.2202999 17.1113281,24.7202999 17,18.7406712 L17,0.240671168",
    id: "BranchLine"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75,22.4387097 C12.75,19.7466412 14.25,16.7401896 14.25,13.4193548 C14.25,10.0985201 12.75,7.09206847 9.75,4.4 C6.75,7.09206847 5.25,10.0985201 5.25,13.4193548 C5.25,16.7401896 6.75,19.7466412 9.75,22.4387097 Z",
    id: "Leafbig",
    transform: "translate(9.750000, 13.419355) rotate(-45.000000) translate(-9.750000, -13.419355) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5625,12.6677419 C24.4375,10.9851991 25.375,9.10616688 25.375,7.03064516 C25.375,4.95512344 24.4375,3.07609118 22.5625,1.39354839 C20.6875,3.07609118 19.75,4.95512344 19.75,7.03064516 C19.75,9.10616688 20.6875,10.9851991 22.5625,12.6677419 Z",
    id: "Leafsm",
    transform: "translate(22.562500, 7.030645) scale(-1, 1) rotate(-45.000000) translate(-22.562500, -7.030645) "
  })))))))));
};
export default SvgPageNotAvailableSmall;